export const html = "<p>Special lunch with tandir khorovats by Chef Mher.</p>\n";
export const leadHtml = "<p>Special lunch with tandir khorovats by Chef Mher.</p>\n";
export const bodyHtml = "";
export const metaText = "Special lunch with tandir khorovats by Chef Mher.";